import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Audit Logs'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Audit Logs',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/audit-logs',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
